/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Iframe_Remote_Subtitle_Export_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to export subtitle: {error}" |
*
* @param {Iframe_Remote_Subtitle_Export_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_subtitle_export_failed_toast = /** @type {((inputs: Iframe_Remote_Subtitle_Export_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Subtitle_Export_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de l'export des sous-titres : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Untertitelexport fehlgeschlagen: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile esportare il sottotitolo: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось экспортировать субтитры: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al exportar el subtítulo: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`字幕导出失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`字幕のエクスポートに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`उपशीर्षक निर्यात करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao exportar legenda: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to export subtitle: ${i?.error}`)
});